export default {
  path: '/privacy',
  name: 'privacy',
  component: () =>
    import(/* webpackChunkName: "auth" */ '@/views/Privacy/index'),
}
